import { Property } from 'csstype'
import React from 'react'

import DashboardCard from './DashboardCard'
import DashboardCardHeader from './DashboardCardHeader'

const CardWrapper: React.FC<{
  renderCardContent: ({ filter }: { filter: string }) => React.ReactNode
  filters?: { value: string; label: string }[]
  defaultFilter?: string
  title: string
  hideFilter?: boolean
  extraText?: React.ReactNode
  overflow?: Property.Overflow
  scrollableDivRef?: React.RefObject<HTMLDivElement>
}> = ({
  renderCardContent,
  scrollableDivRef,
  filters,
  defaultFilter,
  title,
  hideFilter,
  extraText,
  overflow
}) => {
  return (
    <DashboardCard
      defaultFilter={defaultFilter}
      filters={filters}
      headerContent={({ selectedFilter, setSelectedFilter }) => (
        <DashboardCardHeader
          extraText={extraText}
          filters={filters}
          hideFilter={hideFilter}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          title={title}
        />
      )}
      overflow={overflow}
      scrollableDivRef={scrollableDivRef}
      showHoverEffect={false}
    >
      {({ selectedFilter }) => renderCardContent({ filter: selectedFilter })}
    </DashboardCard>
  )
}

export default CardWrapper
